import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, SearchBar, Loader, Empty } from "../components/ui-kit";
import { History } from "lucide-react";

export default function ActivityLog() {
  const [logs, setLogs] = useState(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/activity").then(({ data }) => setLogs(data)).catch(() => setLogs([]));
  }, []);

  if (logs === null) return <Loader />;

  const q = query.trim().toLowerCase();
  const filtered = q
    ? logs.filter((l) => [l.user_nom, l.action, l.cible, l.ancienne_valeur, l.nouvelle_valeur].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)))
    : logs;

  return (
    <div>
      <PageHeader title="Journal d'activité" subtitle="Traçabilité des actions importantes : qui, quand, quoi, ancienne et nouvelle valeur." />
      {logs.length === 0 ? (
        <Empty text="Aucune activité enregistrée pour le moment." />
      ) : (
        <>
          <SearchBar value={query} onChange={setQuery} placeholder="Rechercher par utilisateur, action, cible..." testid="activity-search" count={filtered.length} total={logs.length} />
          {filtered.length === 0 ? <Empty text="Aucun résultat pour cette recherche." /> : (
            <div className="tm-card overflow-x-auto" data-testid="activity-table">
              <table className="tm-table">
                <thead>
                  <tr>
                    <th>Date</th><th>Heure</th><th>Utilisateur</th><th>Action</th><th>Cible</th>
                    <th>Ancienne valeur</th><th>Nouvelle valeur</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((l) => (
                    <tr key={l.id} data-testid={`activity-row-${l.id}`}>
                      <td className="text-[var(--tm-muted)] whitespace-nowrap">{l.date}</td>
                      <td className="text-[var(--tm-muted)] whitespace-nowrap tabular">{l.heure}</td>
                      <td className="font-semibold flex items-center gap-2">
                        <span className="w-6 h-6 rounded-full flex items-center justify-center font-bold text-black text-[10px]" style={{ background: "var(--tm-gold)" }}>{(l.user_nom || "?").charAt(0).toUpperCase()}</span>
                        {l.user_nom}
                      </td>
                      <td><span className="tm-badge" style={{ background: "rgba(212,175,55,.12)", color: "var(--tm-gold)" }}><History size={12} /> {l.action}</span></td>
                      <td className="text-[var(--tm-muted)]">{l.cible || "—"}</td>
                      <td className="text-[var(--tm-muted)]">{l.ancienne_valeur || "—"}</td>
                      <td>{l.nouvelle_valeur || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
